import type { KubernetesIngressProperties } from "@octopusdeploy/legacy-action-properties";
import { KubernetesIngressComponent } from "~/components/Actions/kubernetes/kubernetesIngressComponent";
import type { ActionEditProps } from "../../Actions/pluginRegistry";
import pluginRegistry from "../../Actions/pluginRegistry";
function KubernetesIngressEditFeature(props: ActionEditProps<KubernetesIngressProperties>) {
    return (<KubernetesIngressComponent actionInputsDependencies={props.actionInputsDependencies} properties={props.properties} packages={props.packages} plugin={props.plugin} getFieldError={props.getFieldError} setProperties={props.setProperties} setPackages={props.setPackages} doBusyTask={props.doBusyTask} busy={props.busy} errors={props.errors} projectId={props.projectId} gitRef={props.gitRef} expandedByDefault={props.expandedByDefault} standAlone={false} localNames={props.localNames}/>);
}
pluginRegistry.registerFeature({
    featureName: "Octopus.Features.KubernetesIngress",
    title: "Ingress",
    description: "Defines a Kubernetes Ingress resource, which is used to map HTTP traffic to Service resources based on host name and URL path",
    edit: KubernetesIngressEditFeature,
    priority: 10,
});
